interface ApiErrors {
  [key: string]: string[]; // Chave pode ser qualquer string, e o valor é um array de strings
}

export interface AxiosErrorResponse {
  errors?: ApiErrors;
  message?: string;
  error_code?: string;
}

export const ACCOUNT_BLOCKED_ERROR_CODE = "account_blocked";
export const LOGIN_BLOCKED_ERROR_CODE = "login_blocked";
export const STORE_READ_ONLY_ERROR_CODE = "store_read_only";
export const PENDING_AUTH_TOAST_KEY = "@mundpay_pending_auth_toast";
